<template>
  <v-data-table
    :headers="headers"
    :items="studentTickets"
    :server-items-length="studentTicketCount"
    :options.sync="tableOptions"
    item-key="id"
    sort-by="name"
    :footer-props="tableFooterOptions"
    :loading="loading"
    loading-text="Đang Tải"
  >
    <template v-slot:[`item.subject`]="{ item }">
      <a :href="`/student-tickets/${item.id}`" class="clickable-text">
        {{ item.subject }}
      </a>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.status`]="{ item }">
      {{ item.status | getStatus }}
    </template>
    <template v-slot:[`item.category`]="{ item }">
      {{ item.category | getCategory }}
    </template>
    <template v-slot:[`item.inCharge`]="{ item }">
      <div v-for="person in item.inCharge" :key="person.username">
        {{ getInChargeName(person) }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

const defaultHeaders = [
  {
    text: 'Tiêu đề',
    value: 'subject',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Tên học sinh',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Khối',
    value: 'grade.title',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Kỳ thu',
    value: 'period.title',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Loại phí',
    value: 'category',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Người phụ trách',
    value: 'inCharge',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Bước hỗ trợ',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Trạng thái chi tiết',
    value: 'subStatus',
    align: 'left',
    sortable: false,
    show: true,
  },
]

export default {
  components: {
    CardStudentName,
  },
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
      },
      studentTicketSearchParams: {},
      studentTicketCount: 0,
      loading: false,
    }
  },
  computed: {
    ...mapState('studentTickets', ['studentTickets']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số ticket mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentTicketCount),
      }
      if (this.studentTicketCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    },
  },
  async created() {
    await this.searchStudentTickets({})
  },
  methods: {
    ...mapActions('studentTickets', ['getManyStudentTickets', 'getStudentTicketCount']),
    async searchStudentTickets(studentTicketFilters) {
      this.loading = true
      if (studentTicketFilters) {
        this.getStudentTicketCount(studentTicketFilters)
          .then(response => {
            this.studentTicketCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng học sinh. Lỗi : ', error)
          })
        this.tableOptions.page = 1
        this.studentTicketSearchParams = { ...studentTicketFilters, ...this.pageSetting() }
      } else {
        this.studentTicketSearchParams = { ...this.studentTicketSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getManyStudentTickets({ searchParams: this.studentTicketSearchParams })
      } catch (error) {
        this.$alert.error('Không lấy được danh sách học sinh. Lỗi : ', error)
        console.error(error)
      }
      this.loading = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: 'createdAt:DESC',
      }
    },
    getColor(status) {
      switch (status) {
        case 'active':
          return '#46BE8A'
        case 'reserved':
          return 'orange'
        case 'graduated':
          return 'primary'
        case 'left':
          return 'red'
        default:
          return 'grey'
      }
    },
    getInChargeName(person) {
      return person.name || person.username
    },
  },
  filters: {
    getStatus(status) {
      switch (status) {
        case 'notSeen':
          return 'Chưa hỗ trợ'
        case 'inProgress':
          return 'Đang hỗ trợ'
        case 'closed':
          return 'Đã hỗ trợ'
        default:
          return ''
      }
    },
    getCategory(category) {
      switch (category) {
        case 'cen':
          return 'Học phí'
        case 'decen':
          return 'Thu hộ, chi hộ'
        case 'all':
          return 'Tất cả'
        default:
          return ''
      }
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudentTickets()
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
